import { FC } from 'react';
import './Spinner.scss';

interface Props {
    hideLoader: boolean;
}

export const Spinner: FC<Props> = ({ hideLoader = false }) => {
    return (
        <div className="spinner-overlay">
            <div className={`spinner-border text-primary ${hideLoader && 'hidden'}`} role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};
